export class Utils {
  static isEmpty(value: any): boolean {
    return value === null || value === undefined || (typeof value === "string" && value.trim() === "");
  }

  static deepClone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
  }

  static areObjectsEqual(obj1: any, obj2: any): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  static scrollPageTop() {
    const mainContent = document.querySelector(".main-content") as HTMLElement | null;
    if (mainContent) {
      mainContent.scrollTo({ top: 0, left: 0, behavior: "auto" });
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }
}
